import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';

export class WaitingTransaction {
	@Required
	@Primary
	id: number;

	@Required
	biId: number;

	@Required
	entityName: string;

	@Required
	action: string;

	@Required
	data: any;

	@Required
	tries: number;

	/** Date de mise en file (ms) — absente sur les entrées antérieures à la 2.1.46. */
	creeLe?: number;
}
